/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SortGtaRequest
 */
export interface SortGtaRequest {
    /**
     * 
     * @type {number}
     * @memberof SortGtaRequest
     */
    gta_sort_index?: number;
}

/**
 * Check if a given object implements the SortGtaRequest interface.
 */
export function instanceOfSortGtaRequest(value: object): value is SortGtaRequest {
    return true;
}

export function SortGtaRequestFromJSON(json: any): SortGtaRequest {
    return SortGtaRequestFromJSONTyped(json, false);
}

export function SortGtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SortGtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'gta_sort_index': json['gta_sort_index'] == null ? undefined : json['gta_sort_index'],
    };
}

export function SortGtaRequestToJSON(json: any): SortGtaRequest {
    return SortGtaRequestToJSONTyped(json, false);
}

export function SortGtaRequestToJSONTyped(value?: SortGtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gta_sort_index': value['gta_sort_index'],
    };
}

